import createLucideIcon from '../createLucideIcon';

const Power = createLucideIcon('PowerIcon', [
  ['path', { d: 'M18.36 6.64a9 9 0 1 1-12.73 0', key: 'phirl6' }],
  ['line', { x1: '12', y1: '2', x2: '12', y2: '12', key: '1d1p48' }],
]);

export default Power;
